export const playlistViewContainerCy = 'playlist-view-container';
